// src/App.tsx
import React, { useEffect } from "react";
import Layout from "./components/Layout";
import { ItemDetailsProvider } from "../src/context/ItemDetailsContext";
import ItemDetails from "../src/components/ItemDetails";
import { AppDispatch } from "./app/store";
import { useDispatch } from "react-redux";
import { checkSelectedLanguage, getLanguageSubject } from "./services/localization";
import { interval, throttle } from "rxjs";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchBanners } from "./features/bannersSlice";
import { fetchSettings } from "./features/settingsSlice";
import {
  AuthModalsFromUrl,
  CaptureRefCode,
  ModalProvider,
  Platform,
  RootModals,
  bootstrapSSO,
  configureKeycloakAuthModule
} from 'keycloakauthmodule';
import initializeApp from "./api/init";
import checkAuth from "./api/auth";
import { useNavigate } from "react-router";


configureKeycloakAuthModule({
  baseURL: process.env.REACT_APP_API_SSO_BASE_URL!,
});
// Initializing different libraries
initializeApp();
// Check for login and initialize axios
checkAuth();


const App: React.FC = () => {
  const dispatch: AppDispatch = useDispatch(); // Use AppDispatch
  const [language, setLanguage] = React.useState<string>(checkSelectedLanguage());

  const navigate = useNavigate();

  useEffect(() => {
    bootstrapSSO({
      dispatch,
      publicRoutes: ["/", "/categories", "/search"], // update as needed
      onUnauthorized: () => {
        console.log("🔒 Redirecting to login...");
        window.location.href = "/login"; // avoid `/`, which causes loop
      },
    });
  }, []);

  // Load banners when the component mounts
  useEffect(() => {
    dispatch(fetchBanners('true')); // Fetch all banners on component mount
    dispatch(fetchSettings());

  }, [dispatch]);

  getLanguageSubject
    .pipe(throttle(() => interval(1000)))
    .subscribe({
      next: (lang) => {
        setLanguage(lang as string);
      }
    });

  return (
    <ModalProvider>
      <ItemDetailsProvider>
        <CaptureRefCode />   {/* NEW */}
        <AuthModalsFromUrl />
        <div>
          <Layout />
        </div>
        <RootModals
          platform={Platform.BOXCHAOS}
          redirect={(to) => {
            checkAuth();
            navigate(to, { replace: true }); // uses client-side nav, no extra history entry
          }}
        />
        <ItemDetails />
        <ToastContainer />
      </ItemDetailsProvider>
    </ModalProvider>
  );
};

export default App;
